<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-sort-alt`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M31.25 42a1 1 0 001-1l.001-22.075H38.4a.6.6 0 00.473-.968L29.98 6.527a.999.999 0 00-.283-.249.998.998 0 00-1.696.717V41a1 1 0 001 1h2.25zm-11.67-.18a1 1 0 00.42-.814V7.002a1 1 0 00-1-1h-2.25a1 1 0 00-1 1l-.001 22.075-6.149-.001a.6.6 0 00-.473.968l8.894 11.43a1 1 0 00.283.25.998.998 0 001.276.097z"/></svg>
</template>
<script>

export default {
  name: 'IconSortAlt',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
